/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { BoundSensitive } from "components/form/Sensitive/Sensitive";
import { SensitiveValue } from "client/resources";
import { FormFieldProps } from "components/form";
import React from "react";
import { ResetValue } from "components/form/BoundField/BoundField";

interface SensitiveInputProps extends FormFieldProps<SensitiveValue> {
    resetValue?: ResetValue<SensitiveValue>;
    label: string;
    warning?: string;
    localNames?: string[];
    defaultValueIndicator?: JSX.Element;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
}

const SensitiveInput: React.FC<SensitiveInputProps> = (props) => {
    const { value, resetValue, label, warning, localNames, defaultValueIndicator, onChange, ...rest } = props;
    const formProps = { ...rest, label };

    return (
        <React.Fragment>
            <BoundSensitive
                value={value}
                resetValue={resetValue}
                warning={warning}
                variableLookup={{
                    localNames,
                }}
                onChange={(x) => onChange(x as SensitiveValue)}
                {...formProps}
            />
            {defaultValueIndicator}
        </React.Fragment>
    );
};

export default SensitiveInput;
